module.exports = __webpack_public_path__ + "static/media/earnIcon.87d80cdb.png";